import { Injectable } from '@angular/core';

@Injectable()
export class UtilsService {

    public onlyPositiveNumbers(event: any) {
        const pattern = /[0-9\ ]/;
        const inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar)) {
            // invalid character, prevent input
            event.preventDefault();
        }
    };

    public onlyNumbers(event: any) {
        const pattern = /[0-9\-\ ]/;
        const inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar)) {
            // invalid character, prevent input
            event.preventDefault();
        }
    };

    public onlyTimeCharacters(event: any) {
        const pattern = /[0-9:AMPMampm\-\ ]/;
        const inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar)) {
            // invalid character, prevent input
            event.preventDefault();
        }
    };

    public getFileNameFromHeaders(headers: any, defaultValue: string): string {
          if (headers && headers.has('content-disposition')) {
            const splittedContent = headers.get('content-disposition').split('=');
            return splittedContent[1];
        }
        else {
            return defaultValue;
        }
    }



}
